import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { gsap } from 'gsap';

import './style.css';

export default class NgGameRPGEBuffs extends Component {

    state = {
        buffs: [],
        lvl: 0,
        innerSpeed: undefined
    }

    changePers2Buffs = ({ Pers2, Pers2RelAttackSpeed }) => {
        const { buffs, innerLvl } = Pers2;
        this.setState({ innerSpeed: Pers2RelAttackSpeed, buffs, lvl: innerLvl })

    }

    render() {

        const { arena: { width: arenaWidth }, zIndex } = this.props;
        const { innerSpeed, buffs = [], lvl } = this.state;
        // <img key={`ebea_${id}`} src={`/../images/ver2/snowman/extras/${type}.png`} />

        return <div style={{ zIndex, left: arenaWidth * 0.98, top: arenaWidth * 0.02, columnGap: arenaWidth * 0.007 }} className='ngg_arena_buffs'>
            {!!buffs && buffs.map(({ type }) => {
                return <div key={`ebeabb_${type}`} className='ngg_arena_buffs_buff' style={{ width: arenaWidth * 0.037, height: arenaWidth * 0.037, borderRadius: arenaWidth * 0.005 }}>
                    <img src={`/../images/ver2/snowman/extras/${type}.png`} />
                </div>
            })}
            <span style = {{ fontSize: arenaWidth * 0.032 }} >
                {!!lvl && `LVL: ${lvl}`}
            </span>
            {(innerSpeed !== undefined && innerSpeed !== null) &&
                <img style={{ width: arenaWidth * 0.037, height: arenaWidth * 0.037 }} src={`/../images/ver2/snowman/ui/speed_${innerSpeed}.png`} />}
        </div>
    }
}